import { CheckoutFeature } from '../../models/config/checkout-feature.enum';
import { CheckoutFeatures } from '../../models/config/checkout-features.type';

export const mockCheckoutFeatures: CheckoutFeatures = {
  [CheckoutFeature.TermsAndConditions]: false,
};
